"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _label = require("./label.style");
var _Icon = _interopRequireDefault(require("../../components/Icon"));
var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));
const Label = _ref => {
  let {
    id,
    className,
    label,
    showOptional,
    required,
    tooltipDescription,
    tooltipDescriptionPosition = 'right',
    fit = 'medium',
    orientation = 'vertical'
  } = _ref;
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsxs)(_label.Components.Label, (0, _extends2["default"])({
      className: "".concat(className, "-label"),
      htmlFor: id,
      fit: fit,
      orientation: orientation
    }, {
      children: [(0, _jsxRuntime.jsxs)("span", {
        children: [label, showOptional && !required && (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
          className: "optional"
        }, {
          children: "(optional)"
        })), required && (0, _jsxRuntime.jsx)("span", {
          className: "required"
        })]
      }), !!tooltipDescription && (0, _jsxRuntime.jsx)(_label.Components.LabelTooltip, (0, _extends2["default"])({
        height: '20'
      }, {
        children: (0, _jsxRuntime.jsx)(_Tooltip["default"], (0, _extends2["default"])({
          fit: fit,
          content: tooltipDescription,
          width: 'auto',
          position: tooltipDescriptionPosition,
          appearance: "default"
        }, {
          children: (0, _jsxRuntime.jsx)(_Icon["default"], {
            name: "info-circle",
            size: '20'
          })
        }))
      }))]
    }))
  });
};
var _default = exports["default"] = Label;